

<div  id="body-container">
  <div class="background-blue">
    <div class="breadcrumbs-container container page-banner">
      <h1 style="font-size:22.5px;"><adp-label labelKey="Devices_Title"></adp-label></h1>
    </div>
  </div>
  <div *ngIf="this.accessToken" class="device-inventory-container">
    <pgh-device-breadcrumbs *ngIf="isSPOEEnabled" [hidden]="!isAutoCompleteHidden && isSPOEEnabled" [deviceSearchAddPageTitle]="'Search & Add'" class="container"></pgh-device-breadcrumbs>
    <div [hidden]="!isAutoCompleteHidden && isSPOEEnabled" [ngClass]="isSPOEEnabled ? 'autocomplete-spoe-container':'autocomplete-container'" class="container">
      <aldcs-device-autocomplete (deviceSelectedEvent)="deviceSelected($event)" (noDeviceSatisfactoryEvent)="noDevice($event)"></aldcs-device-autocomplete>
    </div>

    <div class="sandbox-mfe-container container" [ngStyle]="{'margin-bottom':isSPOEEnabled ?'30px':''}">

    <div [hidden]="isAutoCompleteHidden && isSPOEEnabled"><pgh-device-inventory #deviceInventoryComponent [isSelectDeviceView]="false" (handleAddSearchDeviceAction)="handleAddDevice($event);"></pgh-device-inventory></div>

    <adp-setting key="Devices_Promo_IsEnabled"></adp-setting>
    <adp-setting key="Devices_Promo_IsPromoAppType"></adp-setting>
    <div class="container" ifSettingTrue="Devices_Promo_IsEnabled">
      <mat-divider class="divider"></mat-divider>
      <div class="row" *ngIf="isTechServicesChatEnabled">
        <div class="col-12">
          <app-promotion-panel [isDisabledController]="isChatDisabled" [promoSlot]="promoSlot"
            gaName="Home Devices Promotion Panel">
          </app-promotion-panel>
        </div>
      </div>
    </div>
  </div>

</div>
